export const fadeTransition = {
  from: { position: "absolute", opacity: 0, pointerEvents: "none" },
  enter: { position: "absolute", opacity: 1, pointerEvents: "auto" },
  leave: { position: "absolute", opacity: 0, pointerEvents: "none" },
  config: {
    duration: 300,
  },
  delay: 200,
};
